require('babel-polyfill')

import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { isCookieEnabled, getCookie, setCookie, removeCookie } from 'tiny-cookie';

import { api } from '../api/api';

import agent from './modules/agent'; 
import collections from './modules/collections'; 
import communityPlan from './modules/communityPlan'; 
import device from './modules/device'; 
import error from './modules/error'; 
import feature from './modules/feature';
import map from './modules/map';
import mapActivePoint from './modules/mapActivePoint';
import message from './modules/message'; 
import overlay from './modules/overlay';
import plan from './modules/plan';
import parcel from './modules/parcel';
import permit from './modules/permit';
import scroll from './modules/scroll';
import search from './modules/search';
import service from './modules/service';
import sewerMain from './modules/sewer-main';
import stripe from './modules/stripe';
import waterMain from './modules/water-main';
import zoning from './modules/zoning';

Vue.use(Vuex)

export default new Vuex.Store({
	//	mutations can only happen from the store
	strict: true,
	modules: {
		agent,
		collections,
		communityPlan,
		device,
		error,
		feature,
		map,
		mapActivePoint,
		message,
		search,
		overlay,
		plan,
		parcel,
		permit,
		scroll,
		service,
		sewerMain,
		stripe,
		waterMain,
		zoning,
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js